<template>
	<div>
		<div class="row row-slider">
			<div class="col-sm-4">
				<p class="control-label text-right">Temperature</p>
			</div>
			<div class="col-sm-6">
				<input class="slider" id="what-now-temperature" v-model="actions.temperature">
			</div>
			<div class="col-sm-2">
				&deg;C
			</div>
		</div>

		<div class="row row-slider">
			<div class="col-sm-4">
				<p class="control-label text-right">Add DAP</p>
			</div>
			<div class="col-sm-6">
				<input class="slider" id="what-now-add-dap" v-model="actions.dap">
			</div>
			<div class="col-sm-2">
				mg/L
			</div>
		</div>
		<div class="row row-slider">
			<div class="col-sm-4">
				<p class="control-label text-right">Agitator</p>
			</div>
			<div class="col-sm-6">
				<input class="slider" id="what-now-agitator" v-model="actions.agitator">
			</div>
			<div class="col-sm-2">

			</div>
		</div>

		<div class="row row-slider">
			<div class="col-sm-4">
				<p class="control-label text-right">Overseed</p>
			</div>
			<div class="col-sm-6">
				<input class="slider" id="what-now-reinoculate" v-model="actions.reinoculate">
			</div>
			<div class="col-sm-2">
				mg/L
			</div>
		</div>

		<div class="row row-slider">
			<div class="col-sm-4">
				<p class="control-label text-right" style="padding-top:6px;">Pumpover</p>
			</div>
			<div class="col-sm-8">
				<input-toggle name="what_now_pumpover" on="Performed" off="None" on-style="success" :vmodel.sync="actions.pump_over"></input-toggle>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<a v-link="{name: 'ferments.index', params: { fermenterId: fermenter.id, fermentId: ferment.id }}" class="btn btn-primary"><i class="fa fa-arrow-left"></i> Return To Ferment</a>
			</div>
			<div class="col-md-6 text-right">
				<button class="btn btn-primary" :disabled="simulatorRunning" @click.prevent="runSimulation">Run Simulation</button>
			</div>
		</div>

	</div>
</template>

<script>
	import { simulatorRunning, whatNow, ferment, fermenter, loading } from 'vx/getters'
	import { Settings as SettingAction } from 'vx/actions'

	export default {
		vuex: {
			getters: {
				simulatorRunning,
				whatNow,
				ferment,
				fermenter,
				loading
			},

			actions: {
				allWhatNow: SettingAction.allWhatNow
			}
		},

		data() {
			return {
				updateTimeout: null,
				simulateTimeout: null,
				actions: {
					pump_over: false,
					reinoculate: null,
					dap: null,
					agitator: null,
					temperature: null
				}
			};
		},

		watch: {
			simulatorRunning(running) {
				$('.slider.xdsoft').range2DSlider({ disabled: running });
			}
		},

		events: {
			initialize() {
				this.boot();
			}
		},

		ready() {},

		methods: {
			boot() {
				this.allWhatNow().then(() => {
					this.actions.temperature = this.getLastTemperature();
					this.actions.dap = this.whatNow.dap_low;
					this.actions.agitator = this.whatNow.agitator_low;
					this.actions.reinoculate = this.whatNow.reinoculate_low;

					[
						{ id: 'what-now-temperature', ranges: [parseFloat(this.whatNow.temperature_low), parseFloat(this.whatNow.temperature_high)] },
						{ id: 'what-now-add-dap', ranges: [parseFloat(this.whatNow.dap_low), parseFloat(this.whatNow.dap_high)] },
						{ id: 'what-now-agitator', ranges: [parseFloat(this.whatNow.agitator_low), parseFloat(this.whatNow.agitator_high)] },
						{ id: 'what-now-reinoculate', ranges: [parseFloat(this.whatNow.reinoculate_low), parseFloat(this.whatNow.reinoculate_high)] }
					].forEach(slider => {
						$(`#${slider.id}`).range2DSlider({
							grid: true,
							height: 0,
							round: true,
							disabled: false,
							className: 'xdsoft_custom',
							showLegend: [1, 0],
							axis: [slider.ranges],
							tooltip: ['top'],
							alwShowTooltip: [true],
							allowAxisMove: ['x'],
							printLabel: function (val) {
								return parseFloat(val[0]).toFixed(0);
							},
							printValue(val) {
								return parseFloat(val[0][0]).toFixed(0);
							}
						});
					});

					$('#what-now-temperature').range2DSlider({ value: [[this.getLastTemperature(), 0]] });

					this.$watch('actions', actions => {
						clearTimeout(this.updateTimeout);

						if (this.simulateTimeout) {
							this.$dispatch('clearGraphCountdown');

							clearTimeout(this.simulateTimeout);
						}

						this.updateTimeout = setTimeout(() => {
							this.$dispatch('reloadGraphCountdown', 5);

							this.simulateTimeout = setTimeout(() => {
								this.runSimulation();
							}, 5000);
						}, 1500);
					}, { deep: true });
				});
			},

			runSimulation() {
				this.$dispatch('clearGraphCountdown');

				clearTimeout(this.simulateTimeout);
				clearTimeout(this.updateTimeout);

				let clone = $.extend(true, {}, this.ferment);

				clone.dailyData.data.push({
					day: parseFloat(clone.dailyData.data[clone.dailyData.data.length - 1].day) + 1,
					action: {
						data: {
							agitator: this.actions.agitator,
							dap: this.actions.dap,
							pump_over: this.actions.pump_over,
							reinoculate: this.actions.reinoculate
						}
					},
					analysis: {
						data: {}
					},
					temp: this.actions.temperature
				});

				this.$dispatch('reloadGraph', true, clone);
			},

			getLastTemperature() {
				let lastIndex = this.ferment.dailyData.data.length - (this.ferment.dailyData.data.length == 1 ? 1 : 2),
					lastTemperature = parseFloat(this.ferment.dailyData.data[lastIndex].temp);

				return lastTemperature || this.whatNow.temperature_low;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// what-now.vue?6ff0c208